if ( typeof ProductBulkAdd !== 'function' ) {

	class ProductBulkAdd extends HTMLElement {
		constructor(){
			super();
      this.defaultVariant = JSON.parse(this.dataset.defaultVariant);
      this.discountData = this.dataset.discountData ? JSON.parse(this.dataset.discountData) : null;
      this.variantData = JSON.parse(this.dataset.variantData);
      this.inputs = Array.from(this.querySelectorAll('input'));
      this.totalQuantityText = this.querySelector('.bulk-add__total-quantity__value');
      this.totalPriceText = this.querySelector('.bulk-add__total-price__value');
      this.variantButtons = this.querySelectorAll('.bulk-add__table__variant');
      this.productPriceElements = {
        'original': document.querySelector('[data-js-product-price-extended] [data-js-product-price-original]'),
        'compare': document.querySelector('[data-js-product-price-extended] [data-js-product-price-compare]'),
      };
      this.addToCartButton = document.querySelector('[data-js-product-add-to-cart]');

     this.variantButtons.forEach(button => {
        button.addEventListener('mouseenter', (event) => {
          const productVariantsComponent = document.querySelector('product-variants');
          const selectedVariant = this.variantData.find(variant => variant.id === Number(event.target.dataset.variantId));
          productVariantsComponent.currentVariant = selectedVariant;
          productVariantsComponent.currentVariant = selectedVariant;
          productVariantsComponent.dispatchEvent(new Event('VARIANT_CHANGE'));
          productVariantsComponent.updateURL()
        });
      });

      this.inputs.forEach(input => {
        input.addEventListener('input', (event) => this.handleValueChange(event));
      });

      this.calculateTotals();
		}

    handleValueChange(event) {
      const { max } = event.target;
      if (Number(event.target.value) > Number(max)) {
        event.target.value = max;
      }
      this.calculateTotals();
    }

    formatMoney(value) {
      return KROWN.settings.shop_money_format.replace('{{amount}}', value.toFixed(2));
    }

    calculateTotals() {
      const quantityToAdd = this.getTotalQuantity();
      const { totalPrice, totalPriceBefore } = this.calculateTotalPrices();
      const totalDiscountPrice = this.getTotalDiscountPrice();
      const formattedTotalPrice = this.formatMoney(totalPrice);
      const formattedTotalDiscountPrice = this.formatMoney(totalDiscountPrice);
      const saved = totalDiscountPrice < totalPrice ? totalPrice - totalDiscountPrice : 0;
      const formattedSaved = this.formatMoney(saved);
      const savedText = saved > 0 ? `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', formattedSaved)}</span>` : '';
      let discountTextToDisplay = formattedTotalPrice;
      const singleDiscountPrice = this.getDiscountPrice(quantityToAdd);
      
      if (totalDiscountPrice < totalPrice) {
        // update discount price and show
        discountTextToDisplay = `<span>${formattedTotalDiscountPrice}</span><span style="text-decoration: line-through;">${formattedTotalPrice}</span><span>${savedText}</span>`;
        this.productPriceElements.compare.innerHTML = `<span>${formattedTotalPrice}</span><span>${savedText}</span>`;
        this.productPriceElements.original.innerHTML = formattedTotalDiscountPrice;
      } else {
        // if no volumne discount
          //check for compare price then set that 
          // update savings to price vs compare price
       
        const selectedVariants = this.getSelectedVariants();
        const singleSelected = selectedVariants.length === 1;
        if (singleSelected) {
          const selectedVariantInput = selectedVariants[0];
          const selectedVariant = this.variantData.find(variant => Number(variant.id) == Number(selectedVariantInput.id.replace("qty-", "")));
          const selectedVariantQuantity = selectedVariantInput.value;
          const priceHasCompareDiscount = selectedVariant.compare_at_price > selectedVariant.price;
          if (priceHasCompareDiscount) {
            const formattedComparePrice = this.formatMoney((selectedVariant.compare_at_price * selectedVariantQuantity) / 100);
            const compareSaved = ((selectedVariant.compare_at_price * selectedVariantQuantity) - (selectedVariant.price * selectedVariantQuantity)) / 100;
            const formattedCompareSaved = this.formatMoney(compareSaved);
            const comparedSavedText = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', formattedCompareSaved)}</span>`
            this.productPriceElements.original.innerHTML = `<span>${formattedTotalPrice}</span>`;
            this.productPriceElements.compare.innerHTML = `<span>${formattedComparePrice}</span><span>${comparedSavedText}</span>`;
          } else {
            // no discount, single, no compare
            this.productPriceElements.original.innerHTML = `<span>${formattedTotalPrice}</span>`;
            this.productPriceElements.compare.innerHTML = '';
          }
        } else {
          // no discount, multiple
          const noSelectedVariants = !selectedVariants.length;
          if (noSelectedVariants) {
            this.productPriceElements.original.innerHTML = `<span>${formattedTotalPrice}</span>`;
            const priceHasCompareDiscount = this.defaultVariant.compare_at_price > this.defaultVariant.price;
            if (priceHasCompareDiscount) {
              const formattedComparePrice = this.formatMoney((this.defaultVariant.compare_at_price * 1) / 100);
              const compareSaved = ((this.defaultVariant.compare_at_price * 1) - (this.defaultVariant.price * 1)) / 100;
              const formattedCompareSaved = this.formatMoney(compareSaved);
              const comparedSavedText = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', formattedCompareSaved)}</span>`
              this.productPriceElements.compare.innerHTML = `<span>${formattedComparePrice}</span><span>${comparedSavedText}</span>`;
            }
          } else {
            const priceHasCompareDiscount = totalPriceBefore > totalPrice;
            this.productPriceElements.original.innerHTML = `<span>${formattedTotalPrice}</span>`;
            if (priceHasCompareDiscount) {
              const formattedComparePrice = this.formatMoney(totalPriceBefore);
              const saved = totalPriceBefore - totalPrice;
              const formattedSaved = this.formatMoney(saved);
              const comparedSavedText = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', formattedSaved)}</span>`
              this.productPriceElements.compare.innerHTML = `<span>${formattedComparePrice}</span><span>${comparedSavedText}</span>`;
            } else {
              this.productPriceElements.compare.innerHTML = '';
            }
          }
        }
      }
      let unitPrice = this.defaultVariant.price / 100;
      if (singleDiscountPrice) {
        const singleDiscountPriceCents = Number(singleDiscountPrice) * 100;

        if (singleDiscountPriceCents < this.defaultVariant.price) {
          unitPrice = Number(singleDiscountPrice)
        }
      }

      const unitPriceFormatted = this.formatMoney(unitPrice);
      
      this.totalQuantityText.innerText = quantityToAdd;
      this.totalPriceText.innerHTML = unitPriceFormatted;

      if (quantityToAdd > 0) {
        this.handleAddToCartButtonState(true);
      } else {
        this.handleAddToCartButtonState(false);
      }
    }

    handleAddToCartButtonState(enable) {
      if (enable) {
        this.addToCartButton.classList.remove('disabled');
        this.addToCartButton.disabled = false;
      } else {
        this.addToCartButton.classList.add('disabled');
        this.addToCartButton.disabled = true;
      }
    }

    calculateTotalPrices() {
      let totalPrice = 0;
      let totalPriceBefore = 0;
      const selectedVariants = this.getSelectedVariants();
      selectedVariants.forEach(input => {
        const variant = this.variantData.find(variant => Number(variant.id) == Number(input.id.replace("qty-", "")));
        const price = variant.price;
        const compareAtPrice = variant.compare_at_price;
        totalPrice += price * input.value;
        totalPriceBefore += compareAtPrice * input.value;
      });

      const { price, compare_at_price } = this.defaultVariant;

      return {
        totalPrice: totalPrice > 0 ? totalPrice / 100 : price / 100,
        totalPriceBefore: totalPriceBefore > 0 ? totalPriceBefore / 100 : compare_at_price / 100
      }
    }

    getTotalQuantity() {
      const quantityToAdd = this.inputs.reduce((total, input) => {
        return total + parseInt(input.value);
      }, 0);
      return quantityToAdd;
    }

    getTotalDiscountPrice() {
      const quantityToAdd = this.getTotalQuantity();
      const { totalPrice } = this.calculateTotalPrices();
      const discountPrice = this.getDiscountPrice(quantityToAdd);
      if (quantityToAdd === 0) {
        return totalPrice;
      }
      if (discountPrice) {
        return discountPrice * quantityToAdd;
      } else {
        return totalPrice * quantityToAdd;
      }
    }

    getDiscountPrice(quantity) {
      let applicableDiscount = null;
      const discountData = this.discountData?.["0"];
      if (discountData) {
        const discountRules = discountData?.price_level;
        for (let i = 0; i < discountRules.length; i++) {
          if (quantity >= parseInt(discountRules[i].quantity)) {
            applicableDiscount = discountRules[i];
          }
        }

        return applicableDiscount ? applicableDiscount.discount : null;
      }

      return null;
    }

    getSelectedVariants() {
      const selectedVariants = this.inputs.filter(input => input.value > 0);
      return selectedVariants;
    }

    getAddToCartItems() {
      const selectedVariants = this.getSelectedVariants();
      const addToCartItems = selectedVariants.map(input => {
        const variant = this.variantData.find(variant => Number(variant.id) == Number(input.id.replace("qty-", "")));
        return {
          id: variant.id,
          quantity: input.value
        }
      });
      return addToCartItems;
    }
	}

  if ( typeof customElements.get('product-bulk-add') == 'undefined' ) {
    customElements.define('product-bulk-add', ProductBulkAdd);
	}
}